import React from 'react'
import RootStore from '../../stores/RootStore'
import { observer, inject } from 'mobx-react'
import { injectIntl, WrappedComponentProps } from 'react-intl'
import { Elements, TextButton, TextInput, Loader } from '@tfo/common'
import { withRouter, RouteComponentProps } from 'react-router'
import { Link } from 'react-router-dom'
import { ForgotCreatePasswordComplete } from './ForgotCreatePasswordComplete'
import './ForgotCreatePassword.scss'

const { Paragraph } = Elements
export interface IForgotCreatePassword {
	rootStore?: RootStore
}

const ForgotCreatePassword = (
	props: IForgotCreatePassword & WrappedComponentProps & RouteComponentProps,
) => {
	const store = props.rootStore!.forgotCreatePasswordController!
	return (
		<>
			{store.showForgotCreatePasswordComplete ? (<ForgotCreatePasswordComplete />) : (
				<div className="ForgotCreatePassword">
					<div className="ForgotCreatePasswordHeader">
						<Paragraph>
							{props.intl.formatMessage({
								id: 'forgot-create-password',
							})}
						</Paragraph>
					</div>

					<TextInput
						value={store.email}
						onChange={e => store.onChange('email', e.target.value)}
						onKeyDown={e => store.onKeyDown(e.keyCode)}
						onBlur={e => store.onBlur('email', e.target.value)}
						hasError={store.errorModel.errorState.email}
						errorMessage={props.intl.formatMessage({
							id: 'loginpage.errormessage.customer.forgot-create-password',
						})}
						type="email"
						placeholder={props.intl.formatMessage({ id: 'common.email.address' })}
					/>

					<TextButton onClick={() => store.onForgotCreatePassword()}>
						{props.intl.formatMessage({ id: 'loginpage.send' })}
					</TextButton>

					<div className="ForgotPasswordFooter">
						<Paragraph small>
							{props.intl.formatMessage({
								id: 'forgot-create-password.loginPage'
							},
								{
									link: (
										<Link to="/login">
											{props.intl.formatMessage({
												id: 'forgot-create-password.linkText'
											})}
										</Link>
									)
								}
							)}
						</Paragraph>
					</div>
					{store.loading && <Loader />}
				</div>
			)} </>
	)
}

export default withRouter(
	inject('rootStore')(injectIntl(observer(ForgotCreatePassword))),
)
